import { Component, Input } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';

@Component({
    selector: 'ms-speed-reading-result-figure',
    templateUrl: './speed-reading-result-figure.component.html',
    styleUrls: ['./speed-reading-result-figure.component.scss'],
    hostDirectives: [DimensionsListenerDirective],
    standalone: false
})
export class SpeedReadingResultFigureComponent {
  @Input('before') beforeText: string;

  @Input('after') afterText: string;

  wrapperStyles: Partial<CSSStyleDeclaration> = {};

  constructor(private readonly _dimensionsListener: DimensionsListenerDirective) {
    this._dimensionsListener.sizeChanges.subscribe((res) => {
      this.adjust(res.width, res.height);
    });
  }

  adjust(width: number, height: number) {
    this.wrapperStyles = {
      fontSize: Math.min(2.5, width * 0.006, height * 0.008) + 'px',
    };
  }
}
